import React from 'react';
import { StyleProp, ViewStyle, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const ArrowDownToolTip = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 79}
          height={props.height ?? 78}
          viewBox="0 0 79 78"
          fill="none"
          {...props}
        >
          <Path
            d="M33.8515 53.728L34.2755 56.1233C34.4993 57.5985 34.8156 58.8218 35.0123 59.8551L35.2931 61.2662L35.5588 62.3933C35.7054 63.0581 35.8031 63.5701 35.8609 63.961C36.1012 65.523 35.6884 65.1429 35.3631 65.234C35.0378 65.3251 34.9055 65.8355 34.2454 64.3258C34.0863 63.9488 33.8913 63.4453 33.6553 62.7785L33.2582 61.6505L32.8723 60.2256C32.5955 59.1891 32.24 57.9195 31.9731 56.4033L31.5075 53.9432C31.3625 53.0483 31.2573 52.1012 31.1132 51.0748C30.5258 46.2621 30.3998 41.4043 30.7369 36.5676C31.1107 31.3279 32.0431 26.1431 33.5182 21.1015C34.6684 17.0891 36.2175 13.202 38.1422 9.49827C38.7055 8.38647 39.3309 7.30718 40.0153 6.26553C40.491 5.52082 40.7855 5.13374 40.847 5.17229C41.2255 5.36944 37.3813 12.1484 35.1275 21.6239C33.9048 26.6061 33.1669 31.6949 32.9239 36.8193C32.7084 41.5339 32.8905 46.2584 33.4684 50.9424L33.8438 53.7056"
            fill={props.color ?? 'black'}
          />
          <Path
            d="M39.8162 62.4644C41.2314 60.06 42.5544 57.938 43.6867 56.2078C45.9933 52.672 47.6478 50.6182 48.083 50.8726C48.5182 51.127 47.6735 53.6282 45.926 57.4974C45.056 59.4272 43.9689 61.6825 42.7141 64.1784C42.066 65.4335 41.4497 66.6669 40.6611 68.1066C40.1792 69.0389 39.4512 69.8216 38.5561 70.3696C37.9031 70.7301 37.1578 70.889 36.4146 70.826C35.7031 70.7567 35.0155 70.532 34.4004 70.1677C33.5892 69.6368 32.8167 69.0491 32.0886 68.409C31.4087 67.8917 30.7805 67.3064 30.1569 66.7553C28.9172 65.6435 27.7334 64.5589 26.6472 63.4871C24.4577 61.346 22.614 59.3146 21.1371 57.5469C18.1907 54.0018 16.7429 51.5509 17.0964 51.2677C17.4498 50.9845 19.58 52.8812 22.913 55.9383C24.5843 57.4705 26.5249 59.2536 28.8059 61.2342C29.9147 62.2158 31.1063 63.2297 32.3441 64.2634L34.2277 65.8191C34.7934 66.3105 35.3904 66.7647 36.0149 67.1788C36.4917 67.4188 36.3895 67.3718 36.622 67.2879C37.0333 67.0089 37.371 66.6343 37.6059 66.1962C38.3543 64.9101 39.0806 63.653 39.7746 62.4788"
            fill={props.color ?? 'black'}
          />
        </Svg>
      </View>
    );
  },
);

export { ArrowDownToolTip };
